/* Bean Shipper · Every Coffee We Roast (template page.every-coffee), 23 Sep 2026.
   1. Keeps the desktop price bar parked right under whatever part of the fixed site header is on screen.
   2. Mirrors quick-add results on the small Add buttons. Adding is the theme's job: bean-shipper.js
      listens for [data-bs-quick-add], posts to /cart/add.js, opens the drawer and shows a .bs-toast
      (is-error on failure). Without this file the page still renders and every Add still works. */
(function () {
  'use strict';
  var top = document.querySelector('[data-bsec-top]');
  if (!top || top.getAttribute('data-bsec-ready')) return;
  top.setAttribute('data-bsec-ready', '1');

  var bar = top.querySelector('[data-bsec-bar]');
  var header = document.querySelector('header.nav') || document.querySelector('[data-bs-header]');
  var last = -1;
  var ticking = false;
  function sync() {
    ticking = false;
    if (!bar || !header) return;
    var b = Math.round(header.getBoundingClientRect().bottom);
    var v = (b > 0 && b <= 200) ? b : 0;
    if (v !== last) { last = v; bar.style.setProperty('--bsec-top', v + 'px'); }
  }
  function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(sync); } }
  if (bar && header) {
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    sync();
  }

  function watchToast(done) {
    if (!('MutationObserver' in window)) { done(null); return; }
    var finished = false;
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (finished || !n.classList || !n.classList.contains('bs-toast')) return;
          finished = true;
          mo.disconnect();
          done(!n.classList.contains('is-error'));
        });
      });
    });
    mo.observe(document.body, { childList: true });
    window.setTimeout(function () { if (!finished) { finished = true; mo.disconnect(); done(null); } }, 6000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bsec-add]') : null;
    if (!btn || btn.classList.contains('is-busy')) return;
    var orig = btn.getAttribute('data-bsec-label') || btn.textContent;
    btn.setAttribute('data-bsec-label', orig);
    btn.classList.remove('is-added');
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';
    watchToast(function (ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        window.setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = orig; }, 1600);
      } else {
        btn.textContent = orig;
      }
    });
  });
})();
